<div
  role="dialog"
  aria-modal="true"
  aria-labelledby="invite-link-details-title"
  class="w-full max-w-2xl bg-surface-background border border-textbox-border rounded-[8px] shadow-xl overflow-hidden"
>
  <div
    class="px-6 py-5 border-b border-textbox-border flex items-center justify-between gap-4"
  >
    <div class="min-w-0">
      <h2
        id="invite-link-details-title"
        class="text-[22px] font-spaceGrotesk font-semibold text-inverted-neutral"
      >
        Invite link details
      </h2>
      <p class="text-[14px] inter-300 text-support-text mt-1">
        {{ getInviteTypeLabel() }}
      </p>
    </div>
    <button
      type="button"
      (click)="close()"
      class="control-icon-button"
      aria-label="Close invite link details"
    >
      <span class="material-symbols-outlined text-[20px]">close</span>
    </button>
  </div>

  <div class="p-6 space-y-5">
    <div
      class="border border-kek-purple/40 bg-surface-cool rounded-[8px] px-4 py-3"
    >
      <p class="inter-400 text-[14px] text-support-text leading-6">
        {{ getInviteDescription() }}
      </p>
    </div>

    @if (data.url) {
      <div class="space-y-2">
        <label class="inter-500 text-[13px] text-support-text">
          Invite URL
        </label>
        <div class="flex flex-col gap-2 sm:flex-row">
          <input
            class="form-control flex-1 font-mono text-[13px]"
            [ngModel]="data.url"
            readonly
          />
          <button
            type="button"
            [cdkCopyToClipboard]="data.url"
            (click)="copiedToClipboard = true"
            class="bg-transparent border border-nav-btn-border text-nav-btn-text hover:bg-nav-btn-hover-bg hover:text-nav-btn-hover-text px-5 py-2 rounded-full inter-500 text-[14px] transition-colors inline-flex items-center justify-center gap-2"
          >
            <span class="material-symbols-outlined text-[18px]">
              {{ copiedToClipboard ? 'check' : 'content_copy' }}
            </span>
            {{ copiedToClipboard ? 'Copied' : 'Copy URL' }}
          </button>
        </div>
      </div>
    }

    <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
      <div class="border border-textbox-border rounded-[8px] px-4 py-3">
        <p class="inter-500 text-[12px] uppercase text-light-text-color">
          Date created
        </p>
        <p class="inter-400 text-[15px] text-support-text mt-1">
          {{ data.createdAt | date: 'dd/MM/yyyy' }}
        </p>
      </div>
      <div class="border border-textbox-border rounded-[8px] px-4 py-3">
        <p class="inter-500 text-[12px] uppercase text-light-text-color">
          Date modified
        </p>
        <p class="inter-400 text-[15px] text-support-text mt-1">
          {{
            data.modifiedAt
              ? (data.modifiedAt | date: 'dd/MM/yyyy')
              : '--/--/----'
          }}
        </p>
      </div>
    </div>

    <label class="block space-y-2">
      <span class="inter-500 text-[13px] text-support-text">Expiry date</span>
      <input
        type="datetime-local"
        [(ngModel)]="selectedExpiryDate"
        class="form-control"
      />
    </label>
  </div>

  <div
    class="px-6 py-5 border-t border-textbox-border flex flex-wrap justify-end gap-3"
  >
    <button
      type="button"
      (click)="close()"
      class="bg-transparent border border-nav-btn-border text-nav-btn-text hover:bg-nav-btn-hover-bg hover:text-nav-btn-hover-text px-6 py-2 rounded-full inter-500 text-[14px] transition-colors"
    >
      Cancel
    </button>
    <button
      type="button"
      (click)="updateInviteLink()"
      class="bg-transparent border border-kek-purple text-kek-purple hover:bg-kek-purple hover:text-white px-6 py-2 rounded-full inter-500 text-[14px] transition-colors"
    >
      Update
    </button>
  </div>
</div>
